"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stylePalette = exports.getPalette = void 0;

var tslib_1 = require("tslib");

var styled_theming_1 = tslib_1.__importDefault(require("styled-theming"));

var _1 = require("./");

var PALETTE_SHADES = [50, 100, 300, 500, 700, 900];

exports.getPalette = function (name) {
  return Object.keys(_1.themesPalette).reduce(function (acc, themeKey) {
    var t = _1.themesPalette[themeKey];
    acc[themeKey] = t[name];
    return acc;
  }, {});
};

var getShade = function getShade(palettes, shade) {
  return Object.keys(palettes).reduce(function (acc, paletteKey) {
    acc[paletteKey] = palettes[paletteKey][shade];
    return acc;
  }, {});
};

exports.stylePalette = function (name) {
  var palettes = exports.getPalette(name);
  return PALETTE_SHADES.reduce(function (acc, shade) {
    acc[shade] = styled_theming_1.default(name, getShade(palettes, shade));
    return acc;
  }, {});
};